import $ from 'jQuery';
import { initScrollReveal } from './scrollreveal.core.js';

$(function() {
    initScrollReveal();
});